var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4261 89.0579L25.4357 91.184L25.4352 91.3981C25.2961 98.1831 19.6066 103.711 12.69 103.726C5.77343 103.742 0.109344 98.2397 0.00919691 91.4625L0.00976019 91.2484L0 89.1226L0.0210889 83.2793C0.0443463 76.4089 5.77764 70.7672 12.7668 70.7371C19.7559 70.7214 25.4702 76.3445 25.4542 83.222L25.4261 89.0579ZM134.567 99.392L161.254 99.3247C168.243 99.3089 173.969 93.6742 174 86.7823C174.009 79.8977 168.309 74.2886 161.32 74.3044L139.149 74.3546L136.735 74.3671L121.915 74.4006C114.926 74.4163 109.193 80.0583 109.169 86.943L109.14 99.4565L109.142 101.675L109.086 125.875C109.063 132.745 114.77 138.362 121.766 138.353C128.756 138.337 134.496 132.688 134.512 125.811L134.576 101.618L134.567 99.392ZM85.6498 0.0143159L85.6643 3.30671e-05C92.6534 -0.0157316 98.3677 5.6074 98.3517 12.4849L97.9613 161.45C97.9525 168.335 92.2046 173.991 85.2081 174C78.219 174.016 72.5191 168.407 72.5207 161.515L72.9184 12.5424C72.9417 5.67202 78.6679 0.0372267 85.6498 0.0143159ZM49.2148 35.654C56.2039 35.6382 61.904 41.2473 61.9025 48.1391L61.6994 125.996C61.6834 132.86 55.9355 138.516 48.9537 138.539C41.9501 138.54 36.25 132.931 36.266 126.053L36.4691 48.1962C36.4924 41.3258 42.233 35.6769 49.2148 35.654Z",
    fill: "#E101CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app-icon.b4bb88de3557e07855a34fd82dbd02f4.svg";
export { ForwardRef as ReactComponent };